import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DISCOUNTS_TAB, MEMBERSHIPS_TAB, PRODUCTS_TAB, SERVICES_TAB } from '../constants';
import DiscountsList from './DiscountsList';
import Layout from './Layout';
import Products from '../containers/Products';
import Services from './Services';
import * as productsShapes from '../../../products/shapes';
import * as shapes from '../../shapes';
import * as discountShapes from '../../../main/settings/discounts/shapes';
import ChargeModal from '../../payment/containers/ChargeModal';
import MembershipsList from '../../memberships/MembershipsList';
import BarcodeScannerListener from '../containers/BarcodeScannerListener';

const Sale = ({
  products,
  selectedProducts,
  services,
  selectedServices,
  discounts,
  selectedDiscounts,
  addProduct,
  addService,
  addDiscount,
  tab,
  selectTab,
  canShowProducts,
  canShowServices,
  canSellMemberships,
}) => {
  const tabClassName = 'c-btn c-btn--small c-btn--register u-flex-1';
  const isProductsTabSelected = tab === PRODUCTS_TAB;
  const isServicesTabSelected = tab === SERVICES_TAB;
  const isDiscountsTabSelected = tab === DISCOUNTS_TAB;
  const isMembershipsTabSelected = tab === MEMBERSHIPS_TAB;

  return (
    <Layout>
      <ChargeModal />
      <BarcodeScannerListener />
      <div className="o-flexbox o-flexbox--column u-flex-1">

        <div className="c-input-group o-flexbox">
          <button
            type="button"
            className={classnames(
              tabClassName,
              'c-btn--active-yellow',
              { 'is-active': isServicesTabSelected }
            )}
            onClick={selectTab(SERVICES_TAB)}
            disabled={!canShowServices}
          >
            Services
          </button>
          <button
            type="button"
            className={classnames(
              tabClassName,
              'c-btn--active-blue',
              { 'is-active': isProductsTabSelected }
            )}
            onClick={selectTab(PRODUCTS_TAB)}
            disabled={!canShowProducts}
          >
            Products
          </button>
          <button
            type="button"
            className={classnames(
              tabClassName,
              'c-btn--active-red',
              { 'is-active': isDiscountsTabSelected }
            )}
            onClick={selectTab(DISCOUNTS_TAB)}
          >
            Discounts
          </button>
          <button
            type="button"
            display-if={canSellMemberships}
            className={classnames(
              tabClassName,
              'c-btn--active-primary',
              { 'is-active': isMembershipsTabSelected }
            )}
            onClick={selectTab(MEMBERSHIPS_TAB)}
          >
            Memberships
          </button>
        </div>

        <div className="u-ph- u-mt">
          <Products
            products={products}
            selectedProducts={selectedProducts}
            addItem={addProduct}
            display-if={isProductsTabSelected}
          />
          <Services
            services={services}
            selectedServices={selectedServices}
            addItem={addService}
            display-if={isServicesTabSelected}
          />
          <DiscountsList
            discounts={discounts}
            selectedDiscounts={selectedDiscounts}
            addItem={addDiscount}
            display-if={isDiscountsTabSelected}
          />
          <MembershipsList
            display-if={isMembershipsTabSelected}
          />
        </div>

      </div>
    </Layout>
  );
};
Sale.propTypes = {
  products: productsShapes.products,
  selectedProducts: PropTypes.arrayOf(PropTypes.string),
  services: shapes.services,
  selectedServices: PropTypes.arrayOf(PropTypes.string),
  addProduct: shapes.handler,
  addService: shapes.handler,
  tab: shapes.string.isRequired,
  selectTab: shapes.handler.isRequired,
  discounts: discountShapes.discounts,
  selectedDiscounts: PropTypes.arrayOf(PropTypes.string),
  addDiscount: shapes.handler,
  canShowServices: shapes.flag.isRequired,
  canShowProducts: shapes.flag.isRequired,
  canSellMemberships: PropTypes.bool.isRequired,
};
Sale.defaultProps = {
  products: [],
  selectedProducts: [],
  services: [],
  selectedServices: [],
  addProduct: () => null,
  addService: () => null,
  discounts: [],
  selectedDiscounts: [],
  addDiscount: () => null,
};

export default Sale;
